import { RefreshDouble } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconRefreshDouble12Line = createIcon(RefreshDouble, 12, "Line");
export const IconRefreshDouble16Line = createIcon(RefreshDouble, 16, "Line");
export const IconRefreshDouble20Line = createIcon(RefreshDouble, 20, "Line");
export const IconRefreshDouble24Line = createIcon(RefreshDouble, 24, "Line");
export const IconRefreshDouble32Line = createIcon(RefreshDouble, 32, "Line");
export const IconRefreshDouble48Line = createIcon(RefreshDouble, 48, "Line");
export const IconRefreshDouble64Line = createIcon(RefreshDouble, 64, "Line");
